export type LoadStrategy = 'eager' | 'lazy' | 'on-demand';

export interface FontDefinition {
  id: string;           // 唯一标识: "default", "zh-hand", "en-mono"
  name: string;         // 显示名称
  url: string;          // 字体文件路径，空字符串表示系统字体
  priority: number;     // 优先级（越小越高）
  loadStrategy: LoadStrategy;
  fallbacks?: string[]; // 回退字体 ID 列表
  unicodeRanges?: Array<[number, number]>; // 支持的字符范围
}

export const FONT_DEFINITIONS: FontDefinition[] = [
  {
    id: 'system-fallback',
    name: 'System Default',
    url: '', // 空表示使用系统字体（暂不实现，作为概念保留）
    priority: 999,
    loadStrategy: 'eager',
    unicodeRanges: [[0x0000, 0x10FFFF]] // 全部 Unicode 范围
  },
  {
    id: 'default',
    name: 'Chen Yuluoyan',
    url: '/assets/fonts/zh_hand_draw.ttf',
    priority: 1,
    loadStrategy: 'eager',
    fallbacks: ['system-fallback'],
    unicodeRanges: [
      [0x4E00, 0x9FFF],   // CJK 统一表意文字
      [0x3000, 0x303F],   // CJK 符号和标点
      [0xFF00, 0xFFEF],   // 全角 ASCII、全角标点
      [0x0020, 0x007E]    // 基本 ASCII
    ]
  },
  // 未来可以添加更多字体
  // {
  //   id: 'en-handwriting',
  //   name: 'Blokletters Viltstift',
  //   url: '/assets/fonts/Blokletters-Viltstift.ttf',
  //   priority: 2,
  //   loadStrategy: 'lazy',
  //   fallbacks: ['default'],
  //   unicodeRanges: [[0x0020, 0x007E]] // ASCII
  // },
  // {
  //   id: 'emoji',
  //   name: 'Noto Emoji',
  //   url: '/assets/fonts/NotoEmoji-Regular.ttf',
  //   priority: 3,
  //   loadStrategy: 'on-demand',
  //   fallbacks: ['default'],
  //   unicodeRanges: [
  //     [0x1F300, 0x1F9FF],  // Emoji
  //     [0x2600, 0x26FF]     // 杂项符号
  //   ]
  // }
];
